const STORAGE = {
  ACCESS_TOKEN: `accessToken`
};

export { STORAGE };
